var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.batteryStatus)?_c('multiline-tooltip',{attrs:{"label":_vm.tooltip,"type":"is-dark"}},[_c('span',{staticClass:"icon is-small",class:_vm.color},[_c('i',{staticClass:"mdi mdi-18px",class:_vm.icon})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }